import { registerSW } from 'virtual:pwa-register'

/**
 * 서비스워커 갱신 알림.
 *
 * 새 워커가 열려 있는 탭을 바로 인수하면(autoUpdate) 실행 중인 옛 페이지가 그 뒤로
 * 새 빌드의 lazy 청크를 받아오게 된다. 새 청크가 딸려오는 entry 를 다시 평가하면서
 * React context 가 한 벌 더 생기고, 화면은 "provider 안에서 써야 한다"며 터진다.
 *
 * 그래서 새 워커는 대기시키고(prompt), 사용자가 배너를 눌렀을 때 통째로 넘어간다.
 * 하루에 여러 번 배포하는 지금 특히 중요하다.
 */
let applyFn: ((reloadPage?: boolean) => Promise<void>) | null = null
const listeners = new Set<() => void>()
/** 배너가 나중에 붙어도 놓치지 않도록 상태를 들고 있는다. */
let pending = false

/** 탭을 오래 열어두는 사용자를 위해 주기적으로 새 빌드를 확인한다 */
const CHECK_MS = 30 * 60 * 1000

export function initPWA(): void {
  applyFn = registerSW({
    onNeedRefresh() {
      pending = true
      for (const l of listeners) l()
    },
    onRegisteredSW(_url, registration) {
      if (!registration) return
      /*
       * 등록 시점에 한 번만 확인하면, 탭을 켜둔 채 며칠 쓰는 사용자는 옛 빌드에 머문다.
       * 주기적으로, 그리고 탭으로 돌아올 때 확인한다 — 확인은 네트워크 요청 하나다.
       */
      const check = () => void registration.update().catch(() => {})
      window.setInterval(check, CHECK_MS)
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check()
      })
    },
  })
}

export function updatePending(): boolean {
  return pending
}

export function onUpdateReady(fn: () => void): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}

/** 대기 중인 워커를 활성화하고 새로고침한다. */
export function applyUpdate(): void {
  void applyFn?.(true)
}
